import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.any()
export type TagsPatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.infer<typeof tagsPatchMunicipalities_municipalityIdExternalApi_idCollection_points>

export const descriptionPatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.any()
export type DescriptionPatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.infer<typeof descriptionPatchMunicipalities_municipalityIdExternalApi_idCollection_points>

export const paramsPatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.object({ "municipalityId": z.string().uuid(), "id": z.string().uuid() })
export type ParamsPatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.infer<typeof paramsPatchMunicipalities_municipalityIdExternalApi_idCollection_points>

export const bodyPatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.object({ "collectionPointIds": z.array(z.string().uuid()), "collectionPointProfiles": z.record(z.array(z.string())).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.array(z.string()).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}).optional() })
export type BodyPatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.infer<typeof bodyPatchMunicipalities_municipalityIdExternalApi_idCollection_points>

export const responsePatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.object({ "payload": z.object({ "mappedCollectionPointCount": z.number(), "removedCollectionPointCount": z.number(), "movedCollectionPointCount": z.number(), "backfillStarted": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchMunicipalities_municipalityIdExternalApi_idCollection_points = z.infer<typeof responsePatchMunicipalities_municipalityIdExternalApi_idCollection_points>

interface IPatchMunicipalities_municipalityIdExternalApi_idCollection_points extends BaseMethodType {
  tags: TagsPatchMunicipalities_municipalityIdExternalApi_idCollection_points,
  description: DescriptionPatchMunicipalities_municipalityIdExternalApi_idCollection_points,
  params: ParamsPatchMunicipalities_municipalityIdExternalApi_idCollection_points,
  body: BodyPatchMunicipalities_municipalityIdExternalApi_idCollection_points,
  response: ResponsePatchMunicipalities_municipalityIdExternalApi_idCollection_points
}
export const URL = '/municipalities/:municipalityId/externalApi/:id/collection-points'
export const validation = {
  patch: {
    tags: tagsPatchMunicipalities_municipalityIdExternalApi_idCollection_points,
    description: descriptionPatchMunicipalities_municipalityIdExternalApi_idCollection_points,
    params: paramsPatchMunicipalities_municipalityIdExternalApi_idCollection_points,
    body: bodyPatchMunicipalities_municipalityIdExternalApi_idCollection_points,
    response: responsePatchMunicipalities_municipalityIdExternalApi_idCollection_points
  }
}
export interface Municipalities_municipalityIdExternalApi_idCollection_points extends BaseRouteType {
  patch: IPatchMunicipalities_municipalityIdExternalApi_idCollection_points
}